/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Thread_ClosedInputs */

const en_us2_coaching_thread_closed = /** @type {(inputs: Coaching_Thread_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This conversation has ended: the person is no longer in the group.`)
};

const pt_br2_coaching_thread_closed = /** @type {(inputs: Coaching_Thread_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta conversa acabou: a pessoa não está mais na turma.`)
};

const pt_pt2_coaching_thread_closed = /** @type {(inputs: Coaching_Thread_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta conversa acabou: a pessoa não está mais na turma.`)
};

/** @type {(inputs: Coaching_Thread_ClosedInputs) => LocalizedString} */
const es_419_coaching_thread_closed = en_us2_coaching_thread_closed;

/** @type {(inputs: Coaching_Thread_ClosedInputs) => LocalizedString} */
const fr_fr2_coaching_thread_closed = en_us2_coaching_thread_closed;

/** @type {(inputs: Coaching_Thread_ClosedInputs) => LocalizedString} */
const de_de2_coaching_thread_closed = en_us2_coaching_thread_closed;

/** @type {(inputs: Coaching_Thread_ClosedInputs) => LocalizedString} */
const it_it2_coaching_thread_closed = en_us2_coaching_thread_closed;

/**
* | output |
* | --- |
* | "This conversation has ended: the person is no longer in the group." |
*
* @param {Coaching_Thread_ClosedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_thread_closed = /** @type {((inputs?: Coaching_Thread_ClosedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Thread_ClosedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_thread_closed(inputs)
	if (locale === "es-419") return es_419_coaching_thread_closed(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_thread_closed(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_thread_closed(inputs)
	if (locale === "de-DE") return de_de2_coaching_thread_closed(inputs)
	if (locale === "it-IT") return it_it2_coaching_thread_closed(inputs)
	return en_us2_coaching_thread_closed(inputs)
});
export { coaching_thread_closed as "coaching.thread_closed" }